
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auto",
      function () {
        return require("private-next-pages/auto.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auto"])
      });
    }
  